import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { setLanguage, LANGUAGE_LABELS, SUPPORTED_LANGUAGES } from "@/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Languages } from "lucide-react";

// Language picker — every supported UI language, for all roles.
export function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const codes = SUPPORTED_LANGUAGES;
  const current = codes.includes(i18n.resolvedLanguage) ? i18n.resolvedLanguage : "en";

  const change = async (lng) => {
    await setLanguage(lng);
    try { await api.put("/me/language", { language: lng }); } catch (e) { /* offline: local only */ }
  };

  return (
    <Select value={current} onValueChange={change}>
      <SelectTrigger
        data-testid="language-switcher"
        className={compact ? "h-9 w-9 justify-center gap-0 px-0 [&>svg:last-child]:hidden" : "h-9 gap-2"}
        aria-label="Language"
      >
        <Languages className="h-4 w-4 shrink-0" />
        {!compact && <SelectValue />}
      </SelectTrigger>
      <SelectContent>
        {codes.map((c) => (
          <SelectItem key={c} value={c} data-testid={`language-opt-${c}`}>
            {LANGUAGE_LABELS[c]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
